<template>
  <div id="login">
    <el-row class="login-info">
      <el-form label-width="150px"  label-position="right" ref="ruleForm" :model="form" :rules="rules">
        <div class="title">修改专家/企业信息</div>
        <el-form-item label="形象照" prop="avatarAddress" v-if="false">
          <el-upload
            class="upload-wrapper"
            :action="uploadConfig.action"
            :headers="uploadConfig.headers"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :file-list="uploadConfig.fileList"
            :limit="uploadConfig.limit"
            :before-upload="handleBeforeUpload"
            :on-exceed="handleExceed"
            accept=".jpg,.jpeg,.png"
            list-type="picture-card"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传一张jpg/png文件，且不超过1Mb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="形象照" prop="avatarAddress">
          <el-upload
            v-show="!resultImg"
            class="upload-el"
            accept=".jpg,.jpeg,.png"
            ref="fileUpload"
            :action="uploadConfig.action"
            :file-list="uploadConfig.fileList"
            :limit="uploadConfig.limit"
            :data="uploadData"
            :on-change="selectChange"
            list-type="picture-card"
            :auto-upload="false"
            :http-request="httpRequest"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传一张jpg/png文件，且不超过1.5Mb</div>
          </el-upload>

          <cropper
            v-if="showCropper"
            :dialog-visible="showCropper"
            :cropper-img="cropperImg"
            @update-cropper="updateCropper"
            @colse-dialog="closeDialog"
            @upload-img="uploadImg"
          />
        </el-form-item>
        <el-form-item label="选择您是" prop="titleLevel">
          <el-radio-group v-model="radioVal" @input="handleInputChange">
            <el-radio-button label="院士"></el-radio-button>
            <el-radio-button label="教授"></el-radio-button>
            <el-radio-button label="企业高管"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工作单位" prop="workUnit">
          <el-input
            class="login-input"
            v-model="form.workUnit"
            show-word-limit
            :maxlength="50"
          />
        </el-form-item>
        <template v-if="['院士','教授'].includes(radioVal)">
          <el-form-item label="职务职称" prop="officialCapacity">
            <el-input
              class="login-input"
              v-model="form.officialCapacity"
              show-word-limit
              :maxlength="50"
            />
          </el-form-item>
          <el-form-item label="研究方向">
            <el-input
              class="login-input"
              type="textarea"
              v-model="form.researchDirection"
              :rows="6"
              resize="none"
              show-word-limit
              :maxlength="500"
            />
          </el-form-item>
          <el-form-item label="研究成果">
            <el-input
              type="textarea"
              class="login-input"
              v-model="form.achievement"
              :rows="6"
              resize="none"
              show-word-limit
              :maxlength="1000"
            />
          </el-form-item>
        </template>
        <el-form-item label="个人简介" v-if="['院士', '教授'].includes(radioVal)">
          <quill-editor
            class="login-input"
            v-model="form.profile"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)">
          </quill-editor>
        </el-form-item>
        <template v-if="['企业高管'].includes(radioVal)">
          <el-form-item label="职位">
            <el-input
              class="login-input"
              v-model="form.position"
              show-word-limit
              :maxlength="20"
            />
          </el-form-item>
          <el-form-item label="个人简介" v-if="['企业高管'].includes(radioVal)">
            <quill-editor
              class="login-input"
              v-model="form.profile"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)">
            </quill-editor>
          </el-form-item>
          <el-form-item label="企业地址">
            <el-input
              class="login-input"
              v-model="form.enterpriseAddress"
              show-word-limit
              :maxlength="100"
            />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              ref="phone"
              class="login-input"
              v-model="form.enterprisePhone"
              show-word-limit
              :maxlength="20"
              @input="(value) => validatePhoneNumber(value, 'input')"
            />
          </el-form-item>
          <el-form-item label="公司邮箱">
            <el-input
              ref="email"
              class="login-input"
              v-model="form.companyEmail"
              show-word-limit
              :maxlength="50"
              @input="(value)=>validateEmail(value, 'input')"
            />
          </el-form-item>
          <el-form-item label="官网地址">
            <el-input
              type = "text"
              class="login-input"
              v-model="form.companyOfficialWebsiteAddress"
              show-word-limit
              :maxlength="50"
            />
          </el-form-item>
          <el-form-item label="企业介绍">
            <el-input
              type="textarea"
              class="login-input"
              v-model="form.enterpriseIntroduce"
              rows="6"
              resize="none"
              show-word-limit :maxlength="1000"
            />
          </el-form-item>
          <div class="BusinessCaseWrapper">
            <div class="BusinessTitle">
              <span>企业案例</span>
              <div @click="handleToggleBusinessCase">
                <i class="el-icon-arrow-up" v-if="businessCaseDisplay"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </div>
            </div>
            <div class="BusinessContent" v-show="businessCaseDisplay">
              <div class="BusinessItem" v-for="(businessCaseItem, index) of businessCase" :key="`businessCase${index}`">
                <div class="BusinessCaseNum"><span>企业案例{{index+1}}</span><el-button type="text" @click="handleDeleteBusinessCase(index, businessCaseItem)">删除</el-button></div>
                <el-form-item label="标题" label-width="70px" prop="businessCaseName">
                  <el-input
                    v-model="businessCaseItem.title"
                    show-word-limit
                    :maxlength="50"
                  />
                </el-form-item>
                <el-form-item label="案例介绍" label-width="70px" prop="businessCaseName">
                  <el-input type="textarea" rows="5" resize="none" v-model="businessCaseItem.descriptionText" show-word-limit :maxlength="300"  />
                </el-form-item>
                <el-form-item label="图片上传" label-width="70px" v-if="[undefined, null, ''].includes(businessCaseItem['mediaType']) || businessCaseUploadEnable(index, ['1','2'])">
                  <el-upload
                    class="upload-wrapper"
                    :action="businessCaseUploadConfig.action"
                    :headers="businessCaseUploadConfig.headers"
                    :on-success="(response) => handleBusinessCaseUploadSuccess(response,index, 'picture')"
                    :on-remove="(file) => handleBusinessCaseUploadRemove(file, index, 'picture')"
                    :file-list="businessCaseItem.fileList"
                    :limit="businessCaseUploadConfig.limitPicture"
                    :before-upload="(file) => handleOtherBeforeUpload(file,'picture')"
                    :on-exceed="handleExceed"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">最多上传三张jpg/png文件，且不超过1Mb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="视频上传" label-width="70px" v-if="[undefined, null, ''].includes(businessCaseItem['mediaType']) || businessCaseUploadEnable(index, ['3'])">
                  <el-upload
                    class="upload-wrapper"
                    :action="businessCaseUploadConfig.action"
                    :headers="businessCaseUploadConfig.headers"
                    :on-success="(response) => handleBusinessCaseUploadSuccess(response,index,'video')"
                    :on-remove="(file) => handleBusinessCaseUploadRemove(file, index,  'video')"
                    :file-list="businessCaseItem.fileList"
                    :limit="businessCaseUploadConfig.limitVideo"
                    :before-upload="(file)  => handleOtherBeforeUpload(file,'video')"
                    :on-exceed="handleExceed"
                    accept=".mp4"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传一份MP4文件，且大小不超过100mb</div>
                  </el-upload>
                </el-form-item>
              </div>
              <el-button plain icon="el-icon-plus" class="dashed-button" @click="handleAddBusinessCase">添加企业案例</el-button>
            </div>
          </div>
          <div class="ProductTechnologyWrapper">
            <div class="ProductTechnologyTitle">
              <span>产品技术</span>
              <div @click="handleToggleProductTechnology">
                <i class="el-icon-arrow-up" v-if="productTechnologyDisplay"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </div>
            </div>
            <div class="ProductTechnologyContent" v-show="productTechnologyDisplay">
              <div class="ProductTechnologyItem" v-for="(productTechnologyItem, index) of productTechnology" :key="`productTechnology${index}`">
                <div class="ProductTechnologyNum"><span>产品技术{{index+1}}</span><el-button type="text" @click="handleDeleteProductTechnology(index, productTechnologyItem)">删除</el-button></div>
                <el-form-item label="标题" label-width="70px">
                  <el-input  v-model="productTechnologyItem.title" show-word-limit :maxlength="50"  />
                </el-form-item>
                <el-form-item label="产品介绍" label-width="70px">
                  <el-input type="textarea" rows="5" resize="none" v-model="productTechnologyItem.descriptionText" show-word-limit :maxlength="300" />
                </el-form-item>
                <el-form-item label="图片上传" label-width="70px" v-if="[undefined, null, ''].includes(productTechnologyItem['mediaType']) || productTechnologyEnable(index, ['1','2'])">
                  <el-upload
                    class="upload-wrapper"
                    :action="productTechnologyUploadConfig.action"
                    :headers="productTechnologyUploadConfig.headers"
                    :on-success="(response) => handleProductTechnologyUploadSuccess(response,index, 'picture')"
                    :on-remove="(file) => handleProductTechnologyUploadRemove(file, index, 'picture')"
                    :file-list="productTechnologyItem.fileList"
                    :limit="productTechnologyUploadConfig.limitPicture"
                    :before-upload="(file)  => handleOtherBeforeUpload(file,'picture')"
                    :on-exceed="handleExceed"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">最多上传三张jpg/png文件，且不超过1Mb</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="视频上传" label-width="70px" v-if="[undefined, null, ''].includes(productTechnologyItem['mediaType']) || productTechnologyEnable(index, ['3'])">
                  <el-upload
                    class="upload-wrapper"
                    :action="productTechnologyUploadConfig.action"
                    :headers="productTechnologyUploadConfig.headers"
                    :on-success="(response) => handleProductTechnologyUploadSuccess(response,index, 'video')"
                    :on-remove="(file) => handleProductTechnologyUploadRemove(file, index, 'video')"
                    :file-list="productTechnologyItem.fileList"
                    :limit="productTechnologyUploadConfig.limitVideo"
                    :before-upload="(file)  => handleOtherBeforeUpload(file,'video')"
                    :on-exceed="handleExceed"
                    accept=".mp4"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传一份MP4文件，且大小不超过100mb</div>
                  </el-upload>
                </el-form-item>
              </div>
              <el-button plain icon="el-icon-plus" class="dashed-button" @click="handleAddProductTechnology">添加产品技术</el-button>
            </div>
          </div>

        </template>

      </el-form>
      <el-col style="text-align: center" :span="24">
        <el-button @click="handleCancle">取消</el-button>
        <el-button type="warning" @click="regDone('draft')">暂存</el-button>
        <el-button type="primary" @click="regDone('submit')">确定</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import count from "@/api/home";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import axios from "axios";
import Cropper from './Cropper.vue';
export default {
  name: "UserInfoOther",
  components: {
    quillEditor,
    Cropper
  },
  data() {
    return {
      uploadData: { // 上传需要的额外参数

        // siteId: 1,

        // source: 1,

        // fileName: ''

      },

      // action: 'https://jsonplaceholder.typicode.com/posts/', // 上传地址，必填 原版

      cropperImg: '', // 需要裁剪的图片

      showCropper: false, // 是否显示裁剪框

      uploadFile: '', // 裁剪后的文件

      resultImg: '', // 上传成功，后台返回的路径

      radioVal: '院士',
      form: {
        userId: localStorage.getItem("userId"),
        avatarAddress: undefined,
        titleLevel: "1",
        officialCapacity: undefined,
        workUnit: undefined,
        researchDirection: undefined,
        achievement: undefined,
        profile: undefined,
        position: undefined,
        enterpriseAddress: undefined,
        enterprisePhone: undefined,
        companyEmail: undefined,
        companyOfficialWebsiteAddress: undefined,
        enterpriseIntroduce: undefined,
      },
      rules: {
        avatarAddress: [{required: true, message: '请上传形象照', trigger: 'change'}],
        titleLevel: [{required: true, message: '请上传形象照', trigger: 'change'}]
      },
      businessCase:[],
      productTechnology:[],
      editorOption: {
        placeholder: "请输入内容...",
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ 'indent': '-1'}, { 'indent': '+1' }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ['background'],['color'],[{ 'font': [] }],
              [{ 'align': [] }]
            ]
          }
        },
      },
      uploadConfig: {
        action: "/api/app-community/common/upload",
        headers: {
          'Content-Type': 'multipart/form-data',
          timeout: 30000
        },
        limit: 1,
        fileList: []
      },
      businessCaseUploadConfig: {
        action: "/api/app-community/common/upload",
        headers: {
          token: localStorage.getItem("usertoken")
        },
        mediaType: undefined,
        limitPicture: 3,
        limitVideo: 1,
        fileList: []
      },
      productTechnologyUploadConfig: {
        action: "/api/app-community/common/upload",
        headers: {
          token: localStorage.getItem("usertoken")
        },
        limitPicture: 3,
        limitVideo: 1,
        mediaType: undefined,
        fileList: []
      },
      businessCaseDisplay: true,
      productTechnologyDisplay:true,
    };
  },
  computed: {
    modifyParams({form, radioVal}) {
      return form
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    otherParams({businessCase, productTechnology,form}) {
      const businessCaseParams = businessCase.map(param => {
        const mediaAddress = param.fileList.map(item => {
          return item.url
        }).join(',')
        return {
          id: param.id || undefined,
          userId: form.userId,
          title: param.title,
          type: 1,
          descriptionText: param.descriptionText,
          mediaType: param.mediaType,
          mediaAddress
        }
      })
      const productTechnologyParams = productTechnology.map(param => {
        const mediaAddress = param.fileList.map(item => {
          return item.url
        }).join(',')
        return {
          id: param.id || undefined,
          userId: form.userId,
          title: param.title,
          type: 2,
          descriptionText: param.descriptionText,
          mediaType: param.mediaType,
          mediaAddress
        }
      })
      return [...businessCaseParams, ...productTechnologyParams]
    },
    //案例介绍判断只显示图片或者视频
    businessCaseUploadEnable({businessCase}) {
      return function (index, mediaType) {
        return mediaType.includes(businessCase[index].mediaType)
      }
    },
    //产品技术判断只显示图片或者视频
    productTechnologyEnable({productTechnology}) {
      return function (index, mediaType) {
        return mediaType.includes(productTechnology[index].mediaType)
      }
    }
  },
  mounted() {
    this.queryData()
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from, next)
    next()
  },
  methods: {
    // submit 之后会触发此方法
    httpRequest(request) {
      const { action, file } = request;
      const blobFile = this.uploadFile
      const uploadFile = new File([blobFile], file.name, { type: blobFile.type })
      console.log(uploadFile.size/1024/1024, '上传的文件大小')

      const formData = new FormData();
      formData.append('file', uploadFile); // 使用原始文件名
      axios.post(action, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(response => {
        const {data} = response
        console.log(data, '####')
        if(data.code === 0 && data.msg=== "success") {
          this.$message.success("上传成功!")
          this.uploadConfig.fileList = [{
            name: data.file.attachmentName,
            url: data.file.url,
          }]
          this.handleSuccess(data)

        }
      }).catch(() => {
        this.$message.error("上传失败!")
      }).finally(()=>{
        this.showCropper=false
      })
    },


    // 选择文件

    selectChange(file) {

      const { raw, name } = file;

      console.log('raw', file, raw);

      this.openCropper(raw);

      this.uploadData.fileName = name; // 文件名字（需要传递-否则服务器异常）

    },


    /**
     * @param {file} 上传的文件
     */

    openCropper(file) {

      console.log('图片大小控制', file);

      var files = file;

      let isLt5M = (files.size / 1024 / 1024) > 1.5;

      console.log('当前图片兆为：', files.size / 1024/ 1024); // size为字节：先/1024转为KB，再/1024转为兆

      // let isLt5M = files.size > (5 << 20); // 原版

      if (isLt5M) {

        this.$message.error(`请上传1.5M内的图片`);
        this.$refs.fileUpload.clearFiles();
        this.uploadConfig.fileList = []
        return false;
      }

      var reader = new FileReader();

      console.log('reader', reader);


      reader.onload = e => {

        console.log('e', e);

        let data;


        if (typeof e.target.result === 'object') {

          // 把Array Buffer转化为blob 如果是base64不需要

          data = window.URL.createObjectURL(new Blob([e.target.result]));

        } else {

          data = e.target.result;

        }


        console.log('data', data);

        this.cropperImg = data;

      };

      // 转化为base64

      // reader.readAsDataURL(file)

      // 转化为blob

      reader.readAsArrayBuffer(files);

      this.showCropper = true;

    },


    // 上传图片（file为剪裁后的图片）

    uploadImg(file) {
      this.uploadFile = file;
      this.$refs.fileUpload.submit();
      this.$refs.fileUpload.clearFiles(); // 每次submit 都情况下文件列表，避免重复上传之前的文件（多次上传问题）
      this.cropperImg=''
    },


    // 更新图片

    updateCropper() {

      this.$refs.fileUpload.$children[0].$el.click();

    },


    // 关闭窗口

    closeDialog() {
      this.uploadConfig.fileList = []
      this.showCropper = false;
    },

    getUserinfo() {
      count.getDraftById({userId: this.form.userId}).then((res) => {
        const _this=this;
        const {data, code, msg} = res;
        if (code === 0 && msg) {
          for (const dataKey in data) {
            if(this.form.hasOwnProperty(dataKey)) {
              this.form[dataKey] = data[dataKey];
              // 处理头像
              if(dataKey === 'avatarAddress' && !this.uploadConfig.fileList.length) {
                this.uploadConfig.fileList=[{
                  name:'avatarAddress',
                  url: data[dataKey],
                }]
              }
              // 处理是院士、教授、企业高管
              if(dataKey === 'titleLevel') {
                switch (data[dataKey]) {
                  case "1":
                    _this.radioVal = "院士";
                    break;
                  case "2":
                    _this.radioVal = "教授";
                    break;
                  case "3":
                    _this.radioVal = "企业高管";
                    break;
                  default:
                    _this.radioVal = undefined;
                }
              }

            }
          }

          // 处理企业高管-企业案例
          const businessCase = data["sysUserPortfoliosDraft"].filter(item => {
            return item.type === "1"
          })
          this.businessCase = businessCase.map((item, index) => {
            let fileList;
            if(!item.mediaAddress || !item.mediaType) {
              fileList=[]
            }else{
              fileList = item.mediaAddress.split(',').map(itemMediaAddress => {
                return {
                  name: item.mediaType === '3' ? "视频文件" : "图片文件",
                  url: itemMediaAddress
                }
              })
            }

            return {
              id: item.id,
              title: item.title,
              descriptionText: item.descriptionText,
              mediaType: item.mediaType,
              fileList
            }
          })

          const productTechnology = data["sysUserPortfoliosDraft"].filter(item => {
            return item.type === "2";
          })
          this.productTechnology = productTechnology.map(item => {
            let fileList;
            if(!item.mediaAddress || !item.mediaType) {
              fileList=[]
            }else{
              fileList = item.mediaAddress.split(',').map(itemMediaAddress => {
                return {
                  name: item.mediaType === '3' ? "视频文件" : "图片文件",
                  url: itemMediaAddress
                }
              })
            }

            return {
              id: item.id,
              title: item.title,
              descriptionText: item.descriptionText,
              mediaType: item.mediaType,
              fileList
            }
          })
        }
      })
    },
    queryData() {
      this.getUserinfo()
    },
    handleInputChange(value) {
      let titleLevel;
      switch (value) {
        case "院士":
          titleLevel = "1";
          break
        case "教授":
          titleLevel = "2";
          break;
        case "企业高管":
          titleLevel = "3";
          break;
          default:
            break;
      }
      this.form.titleLevel = titleLevel;
    },
    // 确定
    regDone(flag) {
      const _this=this;
      if(
        this.radioVal === "企业高管" &&
        (!this.validatePhoneNumber(this.form.enterprisePhone, 'submit') ||
        !this.validateEmail(this.form.companyEmail, 'submit'))
      ) return

      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          this.$message.error("请正确填写表单")
          return false;
        }

        let allReq = [];
        if(flag === "draft") {
          allReq = [
            count.modifyDraftData(this.modifyParams),
            this.radioVal === "企业高管" && this.otherParams.length > 0 && count.modifyUserOtherInfoDraft(this.otherParams)
          ]
        }
        if(flag === "submit") {
          allReq = [
            count.modifyDraftData(this.modifyParams),
            this.radioVal === "企业高管" && this.otherParams.length > 0 && count.modifyUserOtherInfoDraft(this.otherParams),
            count.modifyUserinfo(this.modifyParams),
            this.radioVal === "企业高管" && this.otherParams.length > 0 && count.modifyUserOtherInfo(this.otherParams)
          ]
        }

        axios.all(allReq).then(axios.spread(function (resBasic, resOther, ...restReg) {
          console.log(restReg, "暂存返回结果");
          const { code:codeBasic, msg:msgBasic } = resBasic;
          const { code:codeOther} = resOther;
          if(codeBasic === 0 && codeOther === 0) {
            if(flag === 'submit') {
              // 保存
              _this.$message.success(msgBasic)
              _this.$router.push({path:'/userInfo'})
            }
            if(flag === 'draft') {
              // 暂存
              _this.$message.success("暂存成功")
            }
          }else if(codeBasic === 0 && !resOther) {
            if(flag === 'submit') {
              _this.$message.success(msgBasic)
              _this.$router.push({path:'/userInfo'})
            }
            if(flag === 'draft') {
              // 暂存
              _this.$message.success("暂存成功")
            }
          }
        })).finally(resp => {
          this.queryData()
        })
      })
    },
    //取消
    handleCancle() {
      this.$router.push({path:'/userInfo'})
    },
    handleSuccess(response, fileImg, fileList) {
      const {code, file, msg } = response
      console.log(code, file, msg )
      code === 0 && msg=== "success" && file.hasOwnProperty('url') && !!file.url && (this.form.avatarAddress = file.url);
    },
    handleRemove() {
      this.form.avatarAddress = undefined;
    },
    handleBeforeUpload(file) {
      const isJPGOrPNG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 <= 1.5;
      if (!isJPGOrPNG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式！");
      }
      if (!isLt500KB) {
        this.$message.error("上传图片大小不能超过 1.5Mb！");
      }

      return isJPGOrPNG && isLt500KB;
    },
    handleExceed(files, fileList) {
      this.$message.info("上传文件已达最大数")
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    handleToggleBusinessCase() {
      this.businessCaseDisplay = !this.businessCaseDisplay;
    },
    handleAddBusinessCase() {
      this.businessCase.push({
        title: undefined,
        descriptionText: undefined,
        mediaType: "",
        fileList: []
      })
    },
    handleDeleteBusinessCase(index, item) {
      this.$confirm("确定删除该案例？").then(async () => {
        if(item.hasOwnProperty("id") && !!item.id){
          count.deleteOtherInfo({id:item.id}).then((resp) => {
            const {code, msg} = resp
            code === 0 && this.$message.success(msg)
          })
        }
        this.businessCase.splice(index, 1);
      }).catch(() => {
        this.$message.info("已取消")
      })
    },
    // 案例介绍图片上传成功
    handleBusinessCaseUploadSuccess(response, index, mediaType) {
      const {file, code, msg} = response;
      if(code === 0 && msg === "success") {
        if(mediaType === "picture") {
          this.businessCase[index]['mediaType'] = "1"
        }
        if(mediaType === "video") {
          this.businessCase[index]['mediaType'] = "3"
        }
        const name = file.hasOwnProperty('attachmentName') &&  file.attachmentName
        const url = file.hasOwnProperty('url') &&  file.url
        this.businessCase[index]['fileList'].push({name,url})
        if(mediaType === "picture" && this.businessCase[index]['fileList'].length > 1) {
          this.businessCase[index]['mediaType'] = "2"
        }
      }
    },
    // 案例介绍删除图片
    handleBusinessCaseUploadRemove(file, index, mediaType) {
      this.businessCase[index]['fileList'] = this.businessCase[index]['fileList'].filter(item => {
        return item.url !== file.url
      })
      if(this.businessCase[index]['fileList'].length === 1 && mediaType === "picture") {
        this.businessCase[index]['mediaType']="1"
      }
      if (this.businessCase[index]['fileList'].length === 0 && mediaType === "picture") {
        this.businessCase[index]['mediaType']=""
      }
      if (this.businessCase[index]['fileList'].length === 0 && mediaType === "video") {
        this.businessCase[index]['mediaType']=""
      }
    },
    // 案例介绍图片上传之前
    handleOtherBeforeUpload(file, mediaType) {
      if(mediaType === "picture") {
        return this.handleBeforeUpload(file)
      }
      if(mediaType === "video") {
        const isVideo = file.type.startsWith('video/');
        const isWithinSizeLimit = file.size / 1024 / 1024 < 1024; // 检查文件大小是否小于1000MB
        if (!isVideo) {
          this.$message.error('只能上传视频文件!');
        }
        if (!isWithinSizeLimit) {
          this.$message.error('上传视频大小不能超过 1024MB!');
        }
        return isVideo && isWithinSizeLimit;
      }
    },
    // 产品技术图片上传成功
    handleProductTechnologyUploadSuccess(response, index, mediaType) {
      const {file, code, msg} = response;
      if(code === 0 && msg === "success") {
        if(mediaType === "picture") {
          this.productTechnology[index]['mediaType'] = "1"
        }
        if(mediaType === "video") {
          this.productTechnology[index]['mediaType'] = "3"
        }
        const name = file.hasOwnProperty('attachmentName') &&  file.attachmentName
        const url = file.hasOwnProperty('url') &&  file.url
        console.log(this.productTechnology[index])
        this.productTechnology[index]['fileList'].push({name,url})
        if(mediaType === "picture" && this.productTechnology[index]['fileList'].length > 1) {
          this.productTechnology[index]['mediaType'] = "2"
        }
      }
    },
    // 产品技术图片删除
    handleProductTechnologyUploadRemove(file, index, mediaType) {
      this.productTechnology[index]['fileList'] = this.productTechnology[index]['fileList'].filter(item => {
        return item.url !== file.url
      })
      if(this.productTechnology[index]['fileList'].length === 1 && mediaType === "picture") {
        this.productTechnology[index]['mediaType']="1"
      }
      if (this.productTechnology[index]['fileList'].length === 0 && mediaType === "picture") {
        this.productTechnology[index]['mediaType']=""
      }
      if (this.productTechnology[index]['fileList'].length === 0 && mediaType === "video") {
        this.productTechnology[index]['mediaType']=""
      }
    },
    handleToggleProductTechnology() {
      this.productTechnologyDisplay = !this.productTechnologyDisplay;
    },
    handleAddProductTechnology() {
      this.productTechnology.push({
        title: undefined,
        descriptionText: undefined,
        mediaType: "",
        fileList: []
      })
    },
    handleDeleteProductTechnology(index, item) {
      this.$confirm("确定删除该产品技术？").then(async () => {
        if(item.hasOwnProperty("id") && !!item.id){
          count.deleteOtherInfo({id:item.id}).then((resp) => {
            const {code, msg} = resp
            code === 0 && this.$message.success(msg)
          })
        }
        this.productTechnology.splice(index, 1);
      }).catch(() => {
        this.$message.info("已取消")
      })
    },
    // 验证邮箱
    validateEmail(value, action) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(value) && action === "input") {
        //this.$message.error('请输入有效的邮箱地址');
      }
      if(value && !emailPattern.test(value) && action === "submit") {
        this.$message.error('请输入有效的邮箱地址');
        this.$refs.email.focus()
        return false
      }else{
        return true
      }
    },
    // 验证联系方式(手机或者座机)
    validatePhoneNumber(value, action) {
      // 正则表达式匹配中国大陆手机号（11位数字，以1开头）
      const mobilePattern = /^1[3-9]\d{9}$/;
      // 正则表达式匹配座机号（可选区号，区号后跟短横线或空格，7到8位数字）
      const landlinePattern = /^($\d{3,4}$|\d{3,4}-)?\d{7,8}$/;

      if (!mobilePattern.test(value) && !landlinePattern.test(value) && action === "input") {
        //this.$message.error('请输入有效的手机号或座机号');
      }
      if(value && !mobilePattern.test(value) && !landlinePattern.test(value) && action === "submit") {
        console.log(value, '输入的值')
        this.$message.error('请输入有效的手机号或座机号');
        this.$refs.phone.focus()
        return false
      }else{
        return true
      }
    }

  },
};
</script>

<style lang="scss" scoped>

#login {
  font-size: 20px;
  width: 100%;
  min-height: 600px;
  background: url("../assets/images/register.png");
  background-position: center center;
  padding-top: 64px;
  padding-bottom: 60px;
}


.login-info {
  width: 1280px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 60px;
  padding: 0 0 40px 0;
  .el-form{
    margin: 0 auto;
    /deep/ .el-form-item{
      .el-form-item__content{
        .el-textarea{
          width: calc(100% - 80px);
        }
        .el-input{
          width: calc(100% - 80px);
        }
        .quill-editor{
          width: calc(100% - 80px);
        }
      }
    }
  }
  .title{
    padding: 24px 24px 24px 0;
    margin: 24px;
    border-bottom: 1px solid #e4e4e4;
    font-weight: bolder;
  }
  .BusinessCaseWrapper, .ProductTechnologyWrapper{
    width: calc(100% - 160px);
    margin: 0 80px 24px 80px;
    .BusinessTitle, .ProductTechnologyTitle{
      line-height: 32px;
      padding: 8px 16px;
      border-radius: 4px;
      background: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
      }
      i{
        color: #ffffff;
        cursor: pointer;
      }
    }
    .BusinessContent, .ProductTechnologyContent{
      width: calc(100%);
      .BusinessItem, .ProductTechnologyItem{
        width: calc(100%);
        margin-top: 24px;
        border:1px solid #E8EBF3;
        padding: 16px;
        border-radius: 4px;
        box-sizing: border-box;
        &:nth-child(2n+1){
          background: #fefefe;
        }
        .BusinessCaseNum, .ProductTechnologyNum{
          height: 32px;
          margin-bottom: 16px;
          color: #333333;
          font-size: 16px;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        /deep/ .el-form-item{
          &:last-child{
            margin-bottom: 0 !important;
          }
          .el-form-item__content{
            .el-textarea{
              width: calc(100%);
            }
            .el-input{
              width: calc(100%);
            }
            .quill-editor{
              width: calc(100%);
            }
          }
        }
      }
      .dashed-button{
        margin-top: 24px;
        width: 100%;
        border-style: dashed; /* 设置边框样式为虚线 */
        border-width: 1px;    /* 设置边框宽度 */
      }
    }

  }
}


.login-input {
  width: 85%;
  margin-bottom: 0px;

}

.reg-text {
  font-size: 12px !important;
  text-align: right;
  width: 95%;
  margin-top: 10px;
}
</style>
<style lang="scss" scoped>
.upload-wrapper{
  /deep/ .el-upload-list--picture-card{
    height: 148px;
    display: inline-block;
    padding: 0;
    margin: 0;
    line-height: 21px;
    .el-upload-list__item{
      margin: 0 10px 0 0;
    }

  }
}
/deep/ .el-tabs{
  .el-tabs__header{
    margin: 0 !important;
    .el-tabs__nav-wrap{
      margin: 0 !important;
      &::after {
        height: 0 !important; /* 移除整个 tab 导航栏下方的分隔线 */
      }
      .el-tabs__nav-scroll{
        .el-tabs__nav{
          border-bottom: none;
          width: 100% !important;
          .el-tabs__active-bar{
            display: none;
          }
          .el-tabs__item{
            width: 50%;
            height: 32px !important;
            line-height: 32px !important;
            padding: 0 20px !important;
            margin: 0;
            text-align: center;
            border-bottom: none !important; /* 强制移除底部边框 */
          }
          .is-active{
            color: #ffffff;
            background: #D7000F !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfoOther.vue